export const CART_ACTION_TYPES = {
  SET_CART_ITEMS: "SET_CART_ITEMS",
  SET_CART_DROP_DOWN: "SET_CART_DROP_DOWN"
};
